import { config } from '../../../config/config';

export type UserFeePercentage = {
  u_id: string;
  u_fee_percentage: number | null;
};

/** One call for every user id that is not already on the loaded ticket rows. */
export async function fetchUserFeePercentages(userIds: string[]): Promise<Record<string, number>> {
  const ids = [...new Set(userIds.map((id) => String(id || '').trim()).filter(Boolean))];
  if (!ids.length) return {};

  const idTokenKey = Object.keys(localStorage).find((key) => key.includes('idToken')) as string;
  const idToken = idTokenKey ? localStorage.getItem(idTokenKey) : '';
  const hasuraRole = localStorage.getItem('x-hasura-user-role');
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (idToken) headers.Authorization = `Bearer ${idToken}`;
  if (hasuraRole) headers['x-hasura-role'] = hasuraRole;

  const nodeApiBaseUrl = (process.env.REACT_APP_NODE_API_URL || config.node_api_url || '').replace(/\/+$/, '');
  const response = await fetch(`${nodeApiBaseUrl}/api/userFeePercentages`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ userIds: ids }),
  });
  const responseData = await response.json().catch(() => ({}));
  if (!response.ok) {
    const message =
      responseData?.message ||
      responseData?.error ||
      responseData?.errors?.[0]?.message ||
      'Failed to load user fee percentages';
    throw new Error(message);
  }

  const fees: Record<string, number> = {};
  for (const row of (responseData?.fees || []) as UserFeePercentage[]) {
    const fee = Number(row?.u_fee_percentage);
    if (row?.u_id && Number.isFinite(fee) && fee > 0) fees[row.u_id] = fee;
  }
  return fees;
}
